(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.flRevealLoaded) return;
    window.flRevealLoaded = true;

    var SELECTOR = '[data-fl-reveal]';
    var HIDDEN_CLASS = 'fl-reveal';
    var SHOWN_CLASS = 'is-revealed';
    var BOUND_KEY = 'flRevealBound';
    var observer = null;

    function motionAllowed() {
      if (!window.matchMedia) return true;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function getObserver() {
      if (observer) return observer;
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add(SHOWN_CLASS);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0 }
      );
      return observer;
    }

    function collect(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var found = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
      if (scope.matches && scope.matches(SELECTOR)) found.unshift(scope);
      return found;
    }

    function init(root) {
      // No observer, or motion turned down: leave every element untouched so it
      // simply stays visible.
      var skip = !('IntersectionObserver' in window) || !motionAllowed();
      collect(root).forEach(function (el) {
        if (el.dataset[BOUND_KEY] === 'true') return;
        el.dataset[BOUND_KEY] = 'true';
        if (skip) return;
        el.classList.add(HIDDEN_CLASS);
        getObserver().observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    class FlSearch extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-search-overlay]');
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.status = this.querySelector('[data-search-status]');
      this.viewAll = this.querySelector('[data-search-viewall]');
      this.lastFocus = null;
      this.controller = null;
      this.debounceId = null;

      // Theme setting: Search > Enable search suggestions. When off, the
      // element never touches the JSON API and the form submits normally.
      this.predictive = this.dataset.predictive === 'true';
      this.showVendor = this.dataset.showVendor === 'true';
      this.showPrice = this.dataset.showPrice === 'true';

      this.predictiveUrl = this.dataset.predictiveUrl || '/search/suggest';
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.currency = this.dataset.currency || 'USD';
      this.moneyFormat = this.dataset.moneyFormat || '';
      this.labels = {
        loading: this.dataset.labelLoading || 'Loading',
        empty: this.dataset.labelEmpty || 'No results for %TERMS%',
        results: this.dataset.labelResults || '%COUNT% results for %TERMS%',
        resultsOne: this.dataset.labelResultsOne || '%COUNT% result for %TERMS%',
        from: this.dataset.labelFrom || 'From',
        suggestions: this.dataset.labelSuggestions || 'Suggestions',
        products: this.dataset.labelProducts || 'Products',
        pages: this.dataset.labelPages || 'Pages',
        articles: this.dataset.labelArticles || 'Articles'
      };

      this._onDocClick = (event) => {
        const opener = event.target && event.target.closest ? event.target.closest('[data-search-open]') : null;
        if (opener) {
          event.preventDefault();
          this.open(opener);
        }
      };
      document.addEventListener('click', this._onDocClick);

      this.querySelectorAll('[data-search-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      const clearBtn = this.querySelector('[data-search-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          this.input.value = '';
          this.renderEmpty();
          this.input.focus();
        });
      }

      // Bound on document only while the overlay is open: a click on a
      // non-interactive part of the panel moves focus to <body>, which is
      // outside <fl-search>, so an element-level listener stopped seeing
      // ESC and Tab entirely.
      this._onKeydown = (event) => {
        if (!this.isOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        } else if (event.key === 'Tab') {
          this.trapFocus(event);
        }
      };

      if (this.input && this.predictive) {
        this.input.addEventListener('input', () => {
          clearTimeout(this.debounceId);
          this.debounceId = setTimeout(() => this.search(this.input.value.trim()), 250);
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onKeydown);
      document.documentElement.style.overflow = '';
    }

    isOpen() {
      return this.overlay && !this.overlay.hidden;
    }

    open(opener) {
      if (!this.overlay || this.isOpen()) return;
      this.lastFocus = opener || document.activeElement;
      document.addEventListener('keydown', this._onKeydown);
      this.overlay.hidden = false;
      void this.overlay.offsetWidth;
      this.overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      document.querySelectorAll('[data-search-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'true');
      });
      if (this.input) {
        this.input.focus();
        this.input.select();
      }
    }

    close() {
      if (!this.overlay || !this.isOpen()) return;
      document.removeEventListener('keydown', this._onKeydown);
      this.overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.querySelectorAll('[data-search-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
      const hide = () => {
        this.overlay.hidden = true;
        this.overlay.removeEventListener('transitionend', hide);
      };
      this.overlay.addEventListener('transitionend', hide);
      setTimeout(() => {
        if (!this.overlay.classList.contains('is-open')) this.overlay.hidden = true;
      }, 400);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    trapFocus(event) {
      const nodes = this.overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
      const focusables = Array.prototype.filter.call(nodes, (el) => el.getClientRects().length > 0);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      // Focus fell outside the dialog (e.g. onto <body>): pull it back in
      // instead of letting Tab reach the page behind the modal.
      if (!this.overlay.contains(document.activeElement)) {
        event.preventDefault();
        if (event.shiftKey) {
          last.focus();
        } else {
          first.focus();
        }
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    setStatus(message) {
      if (this.status) this.status.textContent = message || '';
    }

    renderEmpty() {
      if (this.results) this.results.innerHTML = '';
      this.setStatus('');
      if (this.viewAll) this.viewAll.hidden = true;
    }

    async search(query) {
      if (!this.predictive) return;
      // Abort first, unconditionally: bailing out early on a short query used to
      // leave the previous request in flight, so stale results landed after the
      // field was cleared.
      if (this.controller) this.controller.abort();
      if (!query || query.length < 2) {
        this.renderEmpty();
        return;
      }
      this.controller = new AbortController();
      this.setStatus(this.labels.loading);
      const endpoint =
        this.predictiveUrl +
        '.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=query,product,page,article&resources[limit]=8&resources[limit_scope]=each';
      try {
        const res = await fetch(endpoint, {
          signal: this.controller.signal,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const found = (data && data.resources && data.resources.results) || {};
        this.render(found.queries || [], found.products || [], found.pages || [], found.articles || [], query);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        this.renderEmpty();
      }
    }

    render(queries, products, pages, articles, query) {
      if (!this.results) return;
      this.results.innerHTML = '';
      const total = queries.length + products.length + pages.length + articles.length;

      if (total === 0) {
        this.setStatus(this.labels.empty.replace('%TERMS%', query));
        if (this.viewAll) this.viewAll.hidden = true;
        return;
      }

      const frag = document.createDocumentFragment();
      if (queries.length) frag.appendChild(this.buildTextGroup('suggestions', this.labels.suggestions, queries));
      if (products.length) frag.appendChild(this.buildProductGroup(products));
      if (pages.length) frag.appendChild(this.buildTextGroup('pages', this.labels.pages, pages));
      if (articles.length) frag.appendChild(this.buildTextGroup('articles', this.labels.articles, articles));
      this.results.appendChild(frag);

      const resultsLabel = total === 1 ? this.labels.resultsOne : this.labels.results;
      this.setStatus(resultsLabel.replace('%COUNT%', total).replace('%TERMS%', query));
      if (this.viewAll) {
        this.viewAll.href = this.searchUrl + '?q=' + encodeURIComponent(query);
        this.viewAll.hidden = false;
      }
    }

    buildGroup(key, label, modifier) {
      const wrap = document.createElement('div');
      wrap.className = 'fl-search__group' + (modifier ? ' fl-search__group--' + modifier : '');
      const title = document.createElement('p');
      title.className = 'fl-eyebrow fl-search__group-title';
      title.id = 'FlSearchGroup-' + key;
      title.textContent = label;
      const list = document.createElement('ul');
      list.className = 'fl-search__list' + (modifier ? ' fl-search__list--' + modifier : '');
      list.setAttribute('aria-labelledby', title.id);
      wrap.appendChild(title);
      wrap.appendChild(list);
      return { wrap: wrap, list: list };
    }

    buildTextGroup(key, label, items) {
      const group = this.buildGroup(key, label, null);
      items.forEach((item) => {
        const text = item.text || item.title || '';
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'fl-search__link';
        link.href = item.url || this.searchUrl + '?q=' + encodeURIComponent(text);
        link.textContent = text;
        link.addEventListener('click', () => this.close());
        li.appendChild(link);
        group.list.appendChild(li);
      });
      return group.wrap;
    }

    buildProductGroup(products) {
      const group = this.buildGroup('products', this.labels.products, 'products');
      products.forEach((product) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'fl-search__product';
        link.href = product.url || '#';
        link.addEventListener('click', () => this.close());

        if (product.featured_image && product.featured_image.url) {
          const img = document.createElement('img');
          img.className = 'fl-search__thumb';
          img.src = this.sized(product.featured_image.url, 120);
          img.alt = '';
          img.width = 56;
          img.height = 70;
          img.loading = 'lazy';
          link.appendChild(img);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'fl-search__thumb';
          link.appendChild(placeholder);
        }

        const info = document.createElement('span');
        info.className = 'fl-search__product-info';
        // Theme setting: Search > Show vendor. Above the title, like the card.
        if (this.showVendor && product.vendor) {
          const vendorEl = document.createElement('span');
          vendorEl.className = 'fl-search__product-vendor';
          vendorEl.textContent = product.vendor;
          info.appendChild(vendorEl);
        }
        const title = document.createElement('span');
        title.className = 'fl-search__product-title';
        title.textContent = product.title || '';
        info.appendChild(title);
        // Theme setting: Search > Show price.
        const price = this.showPrice ? this.formatPrice(product) : '';
        if (price) {
          const priceEl = document.createElement('span');
          priceEl.className = 'fl-search__product-price';
          priceEl.textContent = price;
          info.appendChild(priceEl);
        }
        link.appendChild(info);
        li.appendChild(link);
        group.list.appendChild(li);
      });
      return group.wrap;
    }

    sized(url, width) {
      const sep = url.indexOf('?') > -1 ? '&' : '?';
      return url + sep + 'width=' + width;
    }

    formatPrice(product) {
      const rawMin = product.price_min != null ? product.price_min : product.price;
      const rawMax = product.price_max != null ? product.price_max : product.price;
      const min = parseFloat(String(rawMin).replace(',', '.'));
      const max = parseFloat(String(rawMax).replace(',', '.'));
      if (isNaN(min)) return '';
      let out = this.formatMoney(min);
      if (!isNaN(max) && max > min) out = this.labels.from + ' ' + out;
      return out;
    }

    // Honours the shop's own money_format (symbol placement, separators) rather
    // than guessing with Intl, which produced a different string from every
    // price rendered server-side.
    formatMoney(value) {
      if (this.moneyFormat) {
        const rendered = this.moneyFormat.replace(
          /\{\{\s*(\w+)\s*\}\}/,
          (match, token) => this.formatAmount(value, token)
        );
        if (rendered !== this.moneyFormat) return rendered;
      }
      const locale = document.documentElement.lang || 'en';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: this.currency }).format(value);
      } catch (err) {
        return this.currency + ' ' + value.toFixed(2);
      }
    }

    formatAmount(value, token) {
      const noDecimals = token.indexOf('no_decimals') !== -1;
      const comma = token.indexOf('comma_separator') !== -1;
      const apostrophe = token.indexOf('apostrophe_separator') !== -1;
      const decimals = noDecimals ? 0 : 2;
      const fixed = Number(value).toFixed(decimals);
      const parts = fixed.split('.');
      let thousands = ',';
      let decimalMark = '.';
      if (comma) {
        thousands = '.';
        decimalMark = ',';
      } else if (apostrophe) {
        thousands = "'";
      }
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimalMark + parts[1] : parts[0];
    }
  }

  if (!customElements.get('fl-search')) customElements.define('fl-search', FlSearch);
  } catch(e) { console.error(e); }
})();

})();
